import React from "react";
const LoadingCss = () => {
  return <div id="loader"></div>;
};
export default LoadingCss;
